export default __webpack_public_path__ + "static/media/schwab.929a9463.svg";